import React from 'react';
import MaterialList from '@mui/material/List';
import type {ListProps as MaterialListProps} from '@mui/material/List';

export interface ListProps extends MaterialListProps {
    /**
     * Used to replace root node with different
     * component.
     */
    component?: React.ElementType<any>;
}

export const List = React.forwardRef<any, ListProps>(({
    children,
    ...props
}, ref) => (
    <MaterialList
        ref={ref}
        {...props}
    >
        {children}
    </MaterialList>
));

List.displayName = 'List';
